
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../redux/library/selector';
import Table from '../../../../../common/components/table';



export const MarketPlacePolicyProductComponent = ({
    id,
    selectedPolicyCollections,
    setSelectedPolicyCollections,
    products,
    closeModal,
    setSelectedProducts
}: any) => {
    const [currentProducts, setCurrentProducts] = useState<any>([]);
    const libraryData = useSelector(selectListItems)
    const [
      columnDefs,
      setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'MediaMappings.MediaFiles[0].FileMappingURL',
        headerName: 'Image',
        sortable: false,
        filter: false,
        cellRenderer: 'imageRenderer',

      },
      {
        field: 'Name',
        headerName: 'Name',
        sortable: true,
        filter: true,
        isEdit: true,
      },
      {
        field: 'Price',
        headerName: 'Price',
        sortable: true,
        isCurrencyValueFormat: true,
      },
      { field: 'StockQuantity', headerName: 'StockQuantity' },
      {
        field: 'IsPublished',
        headerName: 'Published',
        cellRenderer: 'yesNoRenderer',
      },
      {
        field: 'VendorName',
        headerName: 'Vendor',
        sortable: true,
      },
      {
        field: 'CreatedOnUtc',
        headerName: 'Created On',
        isDateValueFormat: true,
        sortable: true,
      },    
  ]);
  }

  useEffect(() => {
    createColumnDefs();
}, []);

    const handleSelect = (item: any, checked: any) => {
      console.log("Item", checked, item)
      console.log('selectedPolicyCollections?.Marketplaces', selectedPolicyCollections?.Marketplaces)
        const selectedItems = _.find(selectedPolicyCollections?.Marketplaces?.EntityIds, (o: any) => { console.log(o, item.Id); return o === item.Id })
        if (checked && !selectedItems) { // not in collection add
            setCurrentProducts([...currentProducts, item])
            console.log('Added item', selectedPolicyCollections.Marketplaces.EntityIds)

        } else if (!checked && selectedItems) { // in collection, not required. remove
            const newItems = _.map(selectedPolicyCollections?.Marketplaces?.EntityIds, (o: any) => { return o !== item.Id })
            setCurrentProducts(newItems)
        } else {
          console.log('Already present. doing nothing.')
        }
    }

    const handleSelectAll = (items: any[], checked: any) => {
      console.log("Items count", checked, items?.length)
      console.log('items', items)
    }

    const handleSelectProducts = () => {
      const entityIds = [];
      const mapToEntity = _.map(currentProducts, (product: any)=>{ 
        entityIds.push(product.ProductId);  
        return ({     
          "EntityTypeId": 3,
          "EntityTypeName": "Product",
          "EntityId": product.ProductId,
          "EntityName": product.Name,
          "MediaMappings": product.MediaMappings
        })
      })
      setSelectedPolicyCollections({
        ...selectedPolicyCollections,
        Marketplaces: {
          ...selectedPolicyCollections.Marketplaces,
          EntityIds: entityIds
        }
      });
      setSelectedProducts(mapToEntity)
      closeModal();
    }
    return (
        <>
            <Table
                columnData={columnDefs}
                rowData={products}
                onSelect={handleSelect} onSelectAll={handleSelectAll}
                headingName="Products"
            />   

            <div className='flex w-full justify-end items-end'>
            <button
              onClick={closeModal}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            >
              Close
            </button>
            <button
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleSelectProducts}

              type="submit"
            >
              Save
            </button>
          </div>         
        </>
    )
}

export default MarketPlacePolicyProductComponent;
